import React from 'react';
import { VALIDATION_RULES } from '@constants';
import { Select } from '@ui';
import { Col, Form, Row } from 'antd';
import { BANK_COUNTRY_OPTIONS, CURRENCY_OPTIONS } from '../../constants';

const FirstRow = () => {
    return (
        <Row gutter={16}>
            <Col span={12}>
                <Form.Item name='currency' rules={VALIDATION_RULES.REQUIRED}>
                    <Select
                        disabled
                        label='Currency'
                        defaultValue={CURRENCY_OPTIONS[0].value}
                        options={CURRENCY_OPTIONS}
                    />
                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item name='bankCountry' rules={VALIDATION_RULES.REQUIRED}>
                    <Select
                        disabled
                        label='Bank Country'
                        defaultValue={BANK_COUNTRY_OPTIONS[0].value}
                        options={BANK_COUNTRY_OPTIONS}
                    />
                </Form.Item>
            </Col>
        </Row>
    );
};

export default FirstRow;
